import { ModalErrorData } from '@/data/modal-error/entities/modal-error-data.entity';
import { Observable } from 'rxjs';

export abstract class ModalErrorRepository {
    abstract setErrorToModal(payload: ModalErrorData): Observable<never>;
    abstract closeErrorModal(): Observable<never>;
}
